import { gsap, ScrollTrigger } from "./globals.js";
import { animateChars } from './animate-chars.js';

document.addEventListener("DOMContentLoaded", () => {
  const productFrames = document.querySelector(".product-frames");

  // Only run animation if:
  // - .product-frames exists
  // - user is NOT on home OR screen is >= 1025px
  const isHomepage = document.body.classList.contains('home');
  const isWideEnough = window.innerWidth >= 1025;

  if (productFrames && (!isHomepage || isWideEnough)) {
    let frameCount;

    if (typeof blockData !== 'undefined' && Array.isArray(blockData.frame_images)) {
      frameCount = blockData.frame_images.length;
    } else {
      frameCount = 61;
    }

    const currentFrame = index =>
      `${themeVars.libraryUrl}/images/misc/sequence/MBY Car seat explode.1634.${index + 1}.png`;

    const canvas = document.getElementById('productCanvas');
    if (!canvas) return;
    const context = canvas.getContext('2d');

    const headingTL = animateChars('.product-frames__heading');

    const setCanvasSize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    setCanvasSize();

    const images = [];
    const imageSeq = { progress: 0 };

    const loadImages = () => {
      if (images.length) return;
      if (typeof blockData !== 'undefined' && Array.isArray(blockData.frame_images)) {
        blockData.frame_images.forEach(url => {
          const img = new Image();
          img.decoding = 'async';
          img.src = url;
          images.push(img);
        });
      } else {
        for (let i = 0; i < 61; i++) {
          const img = new Image();
          img.decoding = 'async';
          img.src = currentFrame(i);
          images.push(img);
        }
      }
    };

    function render() {
      let frameIndex = Math.round(imageSeq.progress * (frameCount - 1));
      const img = images[frameIndex];
      if (!img) return;

      const scale = Math.max(canvas.width / img.width, canvas.height / img.height);
      const x = (canvas.width / 2) - (img.width / 2) * scale;
      const y = (canvas.height / 2) - (img.height / 2) * scale;

      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(img, x, y, img.width * scale, img.height * scale);
    }

    const initSequence = () => {
      if (!images.length) return;
      images[0].onload = () => render();

      gsap.to(imageSeq, {
        progress: 1,
        ease: "none",
        scrollTrigger: {
          scrub: 1,
          pin: true,
          trigger: productFrames,
          start: "top top",
          end: `+=${frameCount * 30}`,
          anticipatePin: 1
        },
        onUpdate: render
      });
    };

    gsap.from(canvas, {
      y: '-30%',
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: productFrames,
        start: "top bottom",
        end: "top top",
        scrub: true
      }
    });

    ScrollTrigger.create({
      animation: headingTL,
      trigger: productFrames,
      start: "top top",
      end: `+=${frameCount * 30}`,
      scrub: 2,
      onEnter: () => headingTL.play(),
      onLeave: () => headingTL.reverse(),
      onEnterBack: () => headingTL.play(),
      onLeaveBack: () => headingTL.reverse(),
      once: false
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setCanvasSize();
        render();
      }, 120);
    });

    const preloadObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadImages();
        initSequence();
        preloadObserver.disconnect();
      });
    }, { rootMargin: "800px 0px" });

    preloadObserver.observe(productFrames);
  }
});
